/**
 * Customizer pricing helpers (ported from the retail pricing.ts) + a local
 * money formatter mirroring the storefront's Intl.NumberFormat config.
 *
 * Wholesale offers only the upload-logo add-on, but the full flag set is kept
 * so the retail-parity render works unchanged; the non-upload flags simply stay
 * false because those design tools aren't exposed in wholesale.
 */

export function formatMoney(amount, currencyCode) {
  const value = typeof amount === "number" ? amount : parseFloat(amount);
  const safe = Number.isFinite(value) ? value : 0;
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currencyCode || "USD",
    currencyDisplay: "narrowSymbol",
  }).format(safe);
}

export function parseMoneyAmount(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (!value) return 0;
  const normalized = String(value).replace(/[^0-9.-]/g, "");
  const parsed = Number.parseFloat(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function getCustomizerDesignFlags({
  customElements = [],
  customText,
  jerseyNumber,
  jerseyText,
  selectedPresetDesign,
  processedBlob,
} = {}) {
  const hasCustomText = Boolean(customText && customText.trim());
  const hasJersey = Boolean(
    (jerseyNumber && jerseyNumber.trim()) || (jerseyText && jerseyText.trim()),
  );
  const hasGalleryDesign = Boolean(
    selectedPresetDesign ||
      customElements.some((element) => element.isPresetDesign),
  );
  const hasUploadElement = customElements.some(
    (element) =>
      element.type === "image" &&
      !element.isPresetDesign &&
      element.designType !== "jersey" &&
      element.designType !== "custom-text" &&
      (element.designType === "custom-upload" || element.isUploadedLogo),
  );
  const otherDesignActive = hasJersey || hasCustomText || hasGalleryDesign;
  const hasUploadLogo =
    hasUploadElement || (!otherDesignActive && Boolean(processedBlob));

  return { hasUploadLogo, hasCustomText, hasJersey, hasGalleryDesign };
}

export function calculateCustomizerTotal({
  basePrice,
  pricing = {},
  hasUploadLogo,
  hasCustomText,
  hasJersey,
  hasGalleryDesign,
} = {}) {
  let total = parseMoneyAmount(basePrice);
  if (hasUploadLogo) total += parseMoneyAmount(pricing.uploadLogoPrice || "$12.99");
  if (hasCustomText) total += parseMoneyAmount(pricing.customTextPrice || "$9.99");
  if (hasJersey) total += parseMoneyAmount(pricing.jerseyPrice || "$9.99");
  if (hasGalleryDesign) total += parseMoneyAmount(pricing.galleryPrice || "$9.99");
  return total.toFixed(2);
}
